module.exports = __webpack_public_path__ + "static/media/footer-logo.14070403.png";